// extracted by css-extract-rspack-plugin
module.exports =  {"textContainer":"ReadMoreReadLess__textContainer--hVdbC","button":"ReadMoreReadLess__button--jtbOR"};